import { Api } from "@/services/Api";

export default {
  validateUser(param) {
    return Api().post("/api/v2/send-login-otp", param);
  },
  sendResetEmail(param) {
    return Api().post("/api/v2/reset-otp", param);
  },
  updatePassword(param) {
    return Api().post("/api/v1.0/update-password", param);
  },
  logoutUser(token) {
    return Api().put("/api/v2/logout", token);
  },
  userValidation(param) {
    return Api().post("/api/v1.0/validate-user", param);
  },
  login(param) {
    return Api().post("/api/v2/login", param);
  },
  verifyOtpHandler(param) {
    return Api().post("/api/v2/verify-2fa", param);
  }
};
